import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const ChecklistStatus = () => {
    return (
        <Card className="shadow-lg bg-white border-0 h-100">
            <Card.Header className="d-flex align-items-center flex-wrap bg-white px-3 pt-3 pb-1 border-0 gap-2">
                <Card.Title className="fw-bold mb-0 me-auto text-primary fs-20">Checklist Status</Card.Title>
                <Link to="/checklist-status" className="text-decoration-underline small pe-none opacity-50">View All</Link>
            </Card.Header>
            <Card.Body className="p-3 pt-0">
                Checklist - 2 for NIW Received
            </Card.Body>
        </Card>
    )
}

export default ChecklistStatus